import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import colors from "src/utils/colors";
import tw from "src/utils/tw";
import { useMediaQueries } from "src/utils/useMediaQueries";
import InputCheckbox from "../inputs/InputCheckbox";
import { InputText } from "../inputs/InputText";

interface Props {
  activeKey: string;
  selectAll: boolean;
  onSelectAll: () => void;
  disabled?: boolean;
}

export default function FindPrivateLessonsBar(props: Props) {
  const { small } = useMediaQueries();
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const [query, setQuery] = useState(params.get("q"));

  if (small) {
    return null;
  }

  function search() {
    if (!query || query === "") {
      params.delete("q");
    } else {
      params.set("q", query);
    }

    history.replace(`${location.pathname}?${params.toString()}`);
  }

  function handleChange(e) {
    const value = e;

    if (value === "") {
      setQuery(null);
    } else {
      setQuery(value);
    }
  }

  return (
    <div
      className="flex items-center"
      css={{
        padding: "0 1rem",
        height: 50,
        borderBottom: `1px solid ${colors.borderGray}`,
        background: colors.bgGray,
      }}
    >
      <div className="flex flex-1">
        <div>
          <InputCheckbox
            small
            onChange={props.onSelectAll}
            checked={props.selectAll}
          >
            <span
              className="text-sm"
              css={{ fontWeight: "bold", textTransform: "uppercase" }}
            >
              Select All
            </span>
          </InputCheckbox>
        </div>
      </div>

      <div
        className={tw(
          props.disabled && "opacity-50 pointer-events-none sm:hidden",
          "transition-opacity",
          "flex"
        )}
      >
        <InputText
          placeholder="Find in list…"
          value={query || ""}
          onChange={handleChange}
          onPressEnter={search}
          type="search"
          small
        />
      </div>
    </div>
  );
}
